import React from 'react'
import block from 'bem-cn'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { Button, ButtonSizes } from 'components/UIKit'

import './CheckEmailModal.scss'

type CheckEmailModalProps = {
  path: string
}

const b = block('check-email-modal')

export const CheckEmailModal: React.FC<CheckEmailModalProps> = ({ path }) => {
  const { closeModal } = useModalContext()
  const { tPrefix } = useAppTranslation('auth')

  const onClose = () => {
    closeModal(path)()
  }

  return (
    <ModalWrapper title={tPrefix('forgotPassword')} className={b()} onClose={onClose} hideLogo>
      <div className={b('text')}>
        {tPrefix('checkEmailModal.text')}
      </div>

      <Button fullWidth uppercase text={tPrefix('checkEmailModal.button')} onClick={onClose} size={ButtonSizes.MODAL} />
    </ModalWrapper>
  )
}
